module.exports = __webpack_public_path__ + "static/img/row.88cc2b15.svg";